import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Collect — shopping bag for the Collect tab. */
export function CollectIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <path d="M5.5 8h13l-1.2 11.2a1.5 1.5 0 0 1-1.5 1.3H8.2a1.5 1.5 0 0 1-1.5-1.3L5.5 8Z" />
      <path d="M9 10.5V6.8a3 3 0 0 1 6 0v3.7" />
    </PortalIcon>
  );
}
